import Vue from 'vue';
const resource = '/orders';

export default {
  getReceptions(filters = null) {
    let filtersString = this.formatFilters(filters);

    return Vue.prototype.$axiosMainClient.get(
      `${resource}/receptions?${filtersString}`
    );
  },
  getWithOrderItems(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}/${idPublic}?include=orderitems`
    );
  },
  formatFilters(filters) {
    if (filters === null) return '';

    return Object.keys(filters)
      .map((key) => {
        if (filters[key] != null && filters[key]?.length != 0) {
          if (Array.isArray(filters[key])) {
            let listArray = [];
            for (let item of filters[key]) {
              listArray.push(key + '=' + item);
            }
            return listArray.join('&');
          } else {
            return key + '=' + filters[key];
          }
        } else {
          return '';
        }
      })
      .filter((x) => {
        return x != '';
      })
      .join('&');
  },
};
